import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class SMSMessagingService {

    private SMS_MESSAGING_URL = 'api/messaging/sms/{destination}/{body}'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.SMS_MESSAGING_URL;
    }

    sendSMSMessage$(destination: string, body: string): Observable<ScalarResponseModel> {
        let x = this.url.replace('{destination}', destination);
        let y = x.replace('{body}', body);
        return this._httpClient.get<ScalarResponseModel>(`${y}`);
    }

}
